import { render, staticRenderFns } from "./OrAccelerometerSensor.vue?vue&type=template&id=5a39f16b&scoped=true&"
import script from "./OrAccelerometerSensor.vue?vue&type=script&lang=ts&"
export * from "./OrAccelerometerSensor.vue?vue&type=script&lang=ts&"
import style0 from "./OrAccelerometerSensor.vue?vue&type=style&index=0&id=5a39f16b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39f16b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
